import React from 'react';
import './News.css';

import NewsItem from "../newsItem/NewsItem";

class News extends React.Component {
    constructor(props) {
        super(props);
        this.getAllNews();
        this.state = {
            'allNews' : {},
        }
    }
    getAllNews = () => {
        const url = `https://newsapi.org/v2/everything?pageSize=2&q=%D0%BC%D1%96%D0%BD%D1%84%D1%96%D0%BD&sortBy=publishedAt&apiKey=688ab11ed70c475db8ecac56042567bd`;
        fetch(url, {
            method: 'GET',
        })
            .then(data => {
                return data.json()
            })
            .then(data => {
                this.setState({
                    'allNews' : data['articles']
                });
            })
            .catch(() => console.log("Can’t access " + url + " response. Blocked by browser?"))
    };
    getNewsDate = (d) => {
        let date = new Date(d);
        return date.toLocaleDateString();
    };
    render() {
        return (
            <div className="col-xl-3 newsblock lite-shadow">
                <div className="newsblock-title">Популярне</div>
                {Object.keys(this.state.allNews).map( (keyName, i) =>
                    (
                    <NewsItem
                        url={this.state.allNews[keyName]['url']}
                        title={this.state.allNews[keyName]['title']}
                        author={this.state.allNews[keyName]['source']['name']}
                        publicDate={this.getNewsDate(this.state.allNews[keyName].publishedAt)}
                        key={keyName}>
                    </NewsItem>
                ))}
            </div>
        )
    }
}

export default News;